const foodData = [
    {
        title: "Pizza Margherita",
        id: 1,
        img: "https://images.unsplash.com/photo-1670757781705-9b6cb1ad0ca6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=551&q=80",
        maintitle: "Delicious Pizza Margherita",
        rating: 4.5,
        price: 180
    },
    {
        title: "Pasta Carbonara",
        id: 2,
        img: "https://images.unsplash.com/photo-1555949258-eb67b1ef0ceb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=80",
        maintitle: "Classic Pasta Carbonara",
        rating: 4.2,
        price: 190
    },
    {
        title: "Biryani",
        id: 3,
        img: "https://images.unsplash.com/photo-1642821373181-696a54913e93?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=80",
        maintitle: "Flavorful Biryani",
        rating: 4.8,
        price: 200
    },
    {
        title: "Pepperoni Pizza",
        id: 4,
        img: "https://images.unsplash.com/photo-1513104890138-7c749659a591?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=80",
        maintitle: "Tasty Pepperoni Pizza",
        rating: 4.4,
        price: 249
    },
    {
        title: "Chicken Alfredo Pasta",
        id: 5,
        img: "https://images.pexels.com/photos/2611917/pexels-photo-2611917.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        maintitle: "Creamy Chicken Alfredo Pasta",
        rating: 4.6,
        price: 200
    },
    {
        title: "Rogan Josh",
        id: 6,
        img: "https://images.pexels.com/photos/3926133/pexels-photo-3926133.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        maintitle: "Spicy Rogan Josh",
        rating: 4.3,
        price: 199
    },
    {
        title: "Hawaiian Pizza",
        id: 7,
        img: "https://images.unsplash.com/photo-1590947132387-155cc02f3212?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=80",
        maintitle: "Tropical Hawaiian Pizza",
        rating: 4.1,
        price: 199
    },
    {
        title: "Lasagna",
        id: 8,
        img: "https://images.unsplash.com/photo-1592415486689-125cbbfcbee2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=725&q=80",
        maintitle: "Homemade Lasagna",
        rating: 4.7,
        price: 300
    },
    {
        title: "Sushi Platter",
        id: 9,
        img: "https://images.unsplash.com/photo-1617474019977-0e105d1b430e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=362&q=80",
        maintitle: "Fresh and Delicious Sushi Platter",
        rating: 4.7,
        price: 110
    },
    {
        title: "Chicken Tikka Masala",
        id: 10,
        img: "https://images.pexels.com/photos/2994900/pexels-photo-2994900.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        maintitle: "Authentic Chicken Tikka Masala",
        rating: 4.6,
        price: 250
    },
    {
        title: "Mushroom Risotto",
        id: 11,
        img: "https://images.unsplash.com/photo-1592415486689-125cbbfcbee2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=725&q=80",
        maintitle: "Creamy Mushroom Risotto",
        rating: 4.4,
        price: 200
    },
    {
        title: "Tacos",
        id: 12,
        img: "foodimg/gravy.jpg",
        maintitle: "Delightful Tacos",
        rating: 4.3,
        price: 350
    },
    {
        title: "Butter Chicken",
        id: 13,
        img: "foodimg/full chciken.jpg",
        maintitle: "Rich Butter Chicken",
        rating: 4.5,
        price: 200
    },
    {
        title: "Caprese Salad",
        id: 14,
        img: "foodimg/salad.jpg",
        maintitle: "Refreshing Caprese Salad",
        rating: 4.2,
        price: 150
    },
    {
        title: "Fish and Chips",
        id: 15,
        img: "foodimg/unique.jpg",
        maintitle: "Crispy Fish and Chips",
        rating: 4.1,
        price: 210
    },
    {
        title: "Sushi Rolls",
        id: 16,
        img: "https://images.unsplash.com/photo-1539252554453-80ab65ce3586?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=387&q=80",
        maintitle: "Assorted Sushi Rolls",
        rating: 4.7,
        price: 360
    },
    {
        title: "Chicken Shawarma",
        id: 17,
        img: "https://images.unsplash.com/photo-1467003909585-2f8a72700288?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=387&q=80",
        maintitle: "Flavorful Chicken Shawarma",
        rating: 4.5,
        price: 100
    },
    {
        title: "Spaghetti Bolognese",
        id: 18,
        img: "https://images.unsplash.com/photo-1592415486689-125cbbfcbee2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=725&q=80",
        maintitle: "Hearty Spaghetti Bolognese",
        rating: 4.3,
        price: 410
    },
    {
        title: "Beef Burger",
        id: 26,
        img: "https://images.unsplash.com/photo-1671048116810-6f885b2b35a5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=387&q=80",
        maintitle: "Juicy Beef Burger",
        rating: 4.4,
        price: 430
    },
    {
        title: "Crispy Fried Chicken",
        id: 20,
        img: "https://images.pexels.com/photos/2994900/pexels-photo-2994900.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
        ,
        maintitle: "Golden Crispy Fried Chicken",
        rating: 4.4,
        price: 310
    }
    //     {
    //         title: "Caesar Salad",
    //         id: 21,
    //         img: "https://images.unsplash.com/photo-1553909489-cd47e0907980?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=725&q=80"
    //         ,
    //         maintitle: "Classic Caesar Salad",
    //         rating: 4.2,
    //         price: 500
    //     },
    //     {
    //         title: "Mutton Biryani",
    //         id: 22,
    //         img: "https://media.istockphoto.com/id/1142393627/photo/halal-indian-chicken-biryani-served-with-yogurt-tomato-raita-over-white-background-selective.jpg?s=2048x2048&w=is&k=20&c=7tiX-N8ftkXvkB4yac7PybC6Zk-uEXmeY2zFLnhQnFk="
    //         ,
    //         maintitle: "Spiced Mutton Biryani",
    //         rating: 4.8,
    //         price: 440
    //     },
    //     {
    //         title: "Margarita Cocktail",
    //         id: 23,
    //         img:"https://images.unsplash.com/photo-1604917877934-07d8d248d396?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=387&q=80",
    //         maintitle: "Refreshing Margarita Cocktail",
    //         rating: 4.5,
    //         price: 90
    //     },
    //     {
    //         title: "Shrimp Scampi",
    //         id: 24,
    //         img:"https://images.unimgsplash.com/photo-1520201163981-8cc95007dd2a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=387&q=80"
    //  ,
    //         maintitle: "Garlicky Shrimp Scampi",
    //         rating: 4.3,
    //         price: 130
    //     },
    //     {
    //         title: "Fruit Salad",
    //         id: 25,
    //         img:"https://images.unsplash.com/photo-1621841434545-5467e5f73fbd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80",
    //         maintitle: "Fresh and Colorful Fruit Salad",
    //         rating: 4.6,
    //         price: 600
    //     },
    //     {
    //         title: "Beef Burger",
    //         id: 26,
    //         img: "https://images.unsplash.com/photo-1671048116810-6f885b2b35a5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=387&q=80",
    //         maintitle: "Juicy Beef Burger",
    //         rating: 4.4,
    //         price: 130
    //     },
    //     {
    //         title: "Chicken Noodles",
    //         id: 27,
    //         img:"https://images.unsplash.com/photo-1482049016688-2d3e1b311543?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=410&q=80",
    //         maintitle: "Savory Chicken Noodles",
    //         rating: 4.4,
    //         price: 140
    //     }
]

export default foodData;